import arrowLeftSVG from './arrow-left.svg';
import arrowRightSVG from './arrow-right.svg';
import backArrowSVG from './back-arrow.svg';
import checkedIcon from './checked.svg';
import errorIconSVG from './error-icon.svg';
import greyChargerIcon from './grey-charger.png';
import icChargeAuthIcon from './ic_charge_auth_icon.png';
import icChargeMedIcon from './ic_charge_med_icon.png';
import icErrorIcon from './ic_error_icon.png';
import icMarkerBigIcon from './ic_marker_big_icon.png';
import icPlugInVerySmallIcon from './ic_plug_in_very_small_icon.png';
import icStopChargeSuccessIcon from './ic_stop_charge_success_icon.png';
import icTeaCupIcon from './ic_tea_cup_icon.png';
import infoSVG from './info.svg';
import logo from './logo.png';
import logoIcon from './logo-icon.png';
import instavoltLogo from './logo-instavolt.png';
import plusIconSVG from './plus-icon.svg';
import processGIF from './process.gif';
import QRCode from './qr-code.png';
import successSVG from './success.svg';

const images = {
    checkedIcon,
    logoIcon,
    logo,
    icChargeAuthIcon,
    icPlugInVerySmallIcon,
    icTeaCupIcon,
    icMarkerBigIcon,
    icChargeMedIcon,
    icErrorIcon,
    icStopChargeSuccessIcon,
    successSVG,
    errorIconSVG,
    instavoltLogo,
    QRCode,
    backArrowSVG,
    processGIF,
    infoSVG,
    greyChargerIcon,
    plusIconSVG,
    arrowLeftSVG,
    arrowRightSVG,
};

export default images;
